import React, { useEffect, useState } from "react";
import { cdnPath } from "@/utility/api";

const ResumePopupSideBySide = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check when the popup was last shown
    const lastShown = localStorage.getItem("popupLastShown");
    const currentTime = new Date().getTime();

    // Show popup if it's never been shown or it's been more than 24 hours
    if (!lastShown || currentTime - parseInt(lastShown) > 24 * 60 * 60 * 1000) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        // Update the last shown timestamp
        localStorage.setItem("popupLastShown", currentTime.toString());
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = (e) => {
    e.stopPropagation(); // Prevent navigation when closing
    setShowPopup(false);
  };

  // Function to handle navigation when popup is clicked
  const handlePopupClick = () => {
    // Replace this with your desired route/path
    window.location.href = "/resume-maker"; // REPLACE THIS PATH with your desired route
  };

  if (!showPopup) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/70 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) closePopup(e);
      }}
    >
      {/* Popup Container - Completely different layouts for mobile and desktop */}
      <div
        className="relative w-full max-w-4xl rounded-xl overflow-hidden shadow-2xl bg-[#0F172A] cursor-pointer"
        onClick={handlePopupClick}
      >
        {/* Close Button */}
        <button
          onClick={closePopup}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-black/50 text-white z-10 hover:bg-black/70"
        >
          &times;
        </button>

        {/* Desktop Layout - Side by Side */}
        <div className="hidden md:flex">
          {/* Image Side */}
          <div className="w-2/5 flex-shrink-0">
            <img
              src={`${cdnPath}/PopUpResumeV3.png.jpeg`}
              alt="Resume Writing Service"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Side */}
          <div className="p-8 w-3/5 text-white flex flex-col relative">
            {/* 20% Off Tag for Desktop */}
            <div className="absolute -top-2 -left-2 z-10">
              <div className="relative">
                {/* <div
                  className="px-4 py-2 rounded-lg font-bold text-white text-lg shadow-lg transform -rotate-3 animate-pulse"
                  style={{
                    background:
                      "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 50%, #FF6B35 100%)",
                    boxShadow: "0 4px 15px rgba(255, 107, 107, 0.4)",
                  }}
                > */}
                {/* <span className="relative z-10">20% OFF</span> */}
                {/* Shine effect */}
                {/* <div
                    className="absolute inset-0 rounded-lg opacity-30"
                    style={{
                      background: "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.5) 50%, transparent 70%)",
                      animation: "shine 2s infinite"
                    }}
                  ></div> */}
                {/* </div> */}
                {/* Small decorative triangle */}
                <div
                  className="absolute -bottom-1 left-2 w-0 h-0"
                  style={{
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderTop: "8px solid #FF6B35",
                  }}
                ></div>
              </div>
            </div>

            <div className="flex-grow mt-4">
              <h3 className="text-2xl font-bold mb-4">
                Stand Out From The Competition
              </h3>
              <p className="mb-6">
                Our expert resume writers will help you create a powerful,
                ATS-friendly resume that highlights your strengths and gets you
                more interviews.
              </p>

              <div className="space-y-6 mb-6">
                <div className="flex items-start">
                  <div className="bg-purple-600 rounded-full p-1 mr-3 mt-1 flex-shrink-0">
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-bold">ATS-Optimized Format</h4>
                    <p className="text-gray-300 text-sm">
                      Get past automated screening systems
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-600 rounded-full p-1 mr-3 mt-1 flex-shrink-0">
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-bold">Industry-Specific Content</h4>
                    <p className="text-gray-300 text-sm">
                      Tailored to your target roles
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-cyan-600 rounded-full p-1 mr-3 mt-1 flex-shrink-0">
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-bold">48-Hour Turnaround</h4>
                    <p className="text-gray-300 text-sm">
                      Quick delivery for urgent job applications
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Button always at the bottom */}
            <div className="mt-auto pt-4">
              <button
                className="w-full text-white py-3 px-6 rounded-lg font-bold"
                style={{
                  background:
                    "linear-gradient(90deg, #8A5CF7 0%, #3B82F6 100%)",
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Not needed but added for clarity
                  handlePopupClick();
                }}
              >
                Get Your Professional Resume
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Layout - Completely different, optimized for small screens */}
        <div className="flex flex-col md:hidden">
          {/* Mobile Header with small image */}
          <div className="flex items-center p-4 border-b border-gray-800">
            <div className="w-20 h-20 mr-4 flex-shrink-0 rounded-md overflow-hidden">
              <img
                src={`${cdnPath}/PopUpResume.jpg`}
                alt="Resume Writing Service"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white">
                Resume Writing Service
              </h3>
              {/* <div className="text-white font-bold mt-1">
                <span className="bg-gradient-to-r from-orange-500 to-red-500 px-2 py-0.5 rounded text-white text-sm">
                  20% Off
                </span>
              </div> */}
            </div>
          </div>

          {/* Mobile Content */}
          <div className="p-4 text-white">
            <h3 className="text-xl font-bold mb-3">
              Stand Out From The Competition
            </h3>
            <p className="mb-4 text-sm">
              Our expert resume writers will help you create a powerful,
              ATS-friendly resume that highlights your strengths.
            </p>

            <div className="space-y-3 mb-4">
              <div className="flex items-center">
                <div className="bg-purple-600 rounded-full p-1 mr-2 flex-shrink-0">
                  <svg
                    className="h-3 w-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-sm">ATS-Optimized Format</h4>
                </div>
              </div>

              <div className="flex items-center">
                <div className="bg-blue-600 rounded-full p-1 mr-2 flex-shrink-0">
                  <svg
                    className="h-3 w-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-sm">
                    Industry-Specific Content
                  </h4>
                </div>
              </div>

              <div className="flex items-center">
                <div className="bg-cyan-600 rounded-full p-1 mr-2 flex-shrink-0">
                  <svg
                    className="h-3 w-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-sm">48-Hour Turnaround</h4>
                </div>
              </div>
            </div>

            {/* Mobile Button */}
            <button
              className="w-full text-white py-3 px-6 rounded-lg font-bold"
              style={{
                background: "linear-gradient(90deg, #8A5CF7 0%, #3B82F6 100%)",
              }}
              onClick={(e) => {
                e.stopPropagation(); // Not needed but added for clarity
                handlePopupClick();
              }}
            >
              Get Your Professional Resume
            </button>
          </div>
        </div>
      </div>

      {/* CSS for shine animation */}
      {/* <style jsx>{`
        @keyframes shine {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style> */}
    </div>
  );
};

export default ResumePopupSideBySide;
